import { Badge, Button, Divider, Grid, IconButton, Stack } from "@mui/material";
import { withNamespaces } from "react-i18next";
import { SearchFilter } from "../../../components";
import { useStyles } from "../style";

const SearchFilters = ({
    onClick = () => false,
    searchText = "",
    handleSearch = () => false,
    openfilter = () => false,
    filterData = {},
    t

}) => {
    const classes = useStyles()
    return (
        <Grid container justifyContent="space-between">
            <Grid item xs={4}>
                {/*search */}
                <SearchFilter
                    handleChange={handleSearch}
                    value={searchText}
                    placeholder={t("search")}
                    customfieldSx={{ "& .MuiOutlinedInput-root": { height: "40px" }}}
                />
            </Grid>
            <Grid item xs={8} alignContent="flex-end">
                <Stack
                    divider={<Divider orientation="vertical" flexItem sx={{ marginInline: "16px" }} />}
                    justifyContent="flex-end"
                    alignItems="center"
                    direction="row">
                    {
                        filterData?.is_active?.length > 0 || filterData?.is_inventory?.length > 0 ?
                            // <Badge variant="dot" color="primary">
                                <IconButton className={classes.iconButton} onClick={openfilter}>
                                <Badge variant="dot" color="primary">
                                    <img src="/images/filter.svg" alt="filter" />
                                    </Badge>
                                </IconButton>
                            // </Badge>
                            :
                            <IconButton className={classes.iconButton} onClick={openfilter}>
                                <img src="/images/filter.svg" alt="filter" />
                            </IconButton>
                    }


                    {/*add btn */}
                    <Button onClick={onClick} className={classes.addIcon} variant="contained">{t("addItem")}</Button>


                </Stack>
            </Grid>
        </Grid>
    )
}
export default withNamespaces("inspectionItemmaster")(SearchFilters); 